(() => {
  if(customElements.get('vyle-results-gallery'))return;
  customElements.define('vyle-results-gallery',class extends HTMLElement{
    connectedCallback(){
      this._abort?.abort();this._abort=new AbortController();
      this._cases=[...this.querySelectorAll('[data-results-case]')];this._index=0;this._selected=null;
      this._category=this._cases[0]?.dataset.category||'all';
      this.addEventListener('click',event=>{
        const button=event.target.closest('button');if(!button)return;
        if(button.hasAttribute('data-results-filter')){
          const category=button.dataset.resultsFilter;
          this._index=category==='all'?0:this._cases.findIndex(item=>item.dataset.category===category);
          this._category=category;
        }else if(button.hasAttribute('data-results-go')){
          this._index=this._cases.findIndex(item=>item.dataset.resultsCase===button.dataset.resultsGo);
          this._category=this._cases[this._index]?.dataset.category;
        }else if(button.hasAttribute('data-results-prev')||button.hasAttribute('data-results-next')){
          this._index+=button.hasAttribute('data-results-prev')?-1:1;
          this._index=Math.max(0,Math.min(this._index,this._cases.length-1));
          this._category=this._cases[this._index]?.dataset.category;
        }else return;
        this._update(true);
      },{signal:this._abort.signal});this._update(false);
    }
    _update(animate){
      this._index=Math.max(0,Math.min(this._index,this._cases.length-1));
      const selected=this._cases[this._index],changed=selected!==this._selected;
      this._cases.forEach(item=>item.hidden=item!==selected);
      this.querySelectorAll('[data-results-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.resultsFilter===this._category)));
      this.querySelectorAll('[data-results-go]').forEach(button=>{
        button.hidden=false;
        if(button.dataset.resultsGo===selected?.dataset.resultsCase)button.setAttribute('aria-current','true');
        else button.removeAttribute('aria-current');
      });
      this.querySelector('[data-results-prev]').disabled=this._index===0;
      this.querySelector('[data-results-next]').disabled=this._index>=this._cases.length-1;
      this.querySelector('[data-results-status]').textContent=selected?`${this._index+1} / ${this._cases.length}`:'No case studies';
      if(animate&&changed&&selected&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        selected.querySelectorAll('.vyle-results__pair,.vyle-results__copy').forEach(element=>{
          element.getAnimations?.().forEach(animation=>animation.cancel());
          element.animate?.([{opacity:.35},{opacity:1}],{duration:240,easing:'ease-out'});
        });
      }
      if(animate){
        this._reveal(this.querySelector('.vyle-results__thumbnails'),this.querySelector('[data-results-go][aria-current="true"]'));
        this._reveal(this.querySelector('.vyle-results__filters'),this.querySelector('[data-results-filter][aria-pressed="true"]'));
      }
      this._selected=selected;
    }
    _reveal(rail,item){
      if(!rail||!item)return;
      const r=rail.getBoundingClientRect(),i=item.getBoundingClientRect();
      if(i.left<r.left)rail.scrollLeft-=r.left-i.left;
      else if(i.right>r.right)rail.scrollLeft+=i.right-r.right;
      if(i.top<r.top)rail.scrollTop-=r.top-i.top;
      else if(i.bottom>r.bottom)rail.scrollTop+=i.bottom-r.bottom;
    }
    disconnectedCallback(){this._abort?.abort();}
  });
})();
